import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/GoogleAuthContext";

export default function ProtectedRoute() {
  const { user } = useAuth();
  const location = useLocation();



  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }


  return <Outlet />;
}